package com.example.readingnotes.presentation.theme

enum class ThemeMode {
    LIGHT,
    DARK,
    SYSTEM,
}

data class ThemeState(
    val themeMode: ThemeMode = ThemeMode.SYSTEM,
    val isDarkMode: Boolean = false,
)
